import { ContractPairMaxTpRatios } from '@ui/services/contract/hooks/TradingConfigFacet/useGetPairMaxTpRatios/query';
import { isEmpty, isNil } from 'lodash-es';

export const getMaxTpRatios = ({
  leverage,
  currentPairMaxTpRatios,
  maxTakeProfitP,
}: {
  leverage: number;
  currentPairMaxTpRatios: ContractPairMaxTpRatios[];
  maxTakeProfitP: number;
}) => {
  let targetMaxTpRatios;

  // if do not define maxTpRatios array, use global one
  if (isEmpty(currentPairMaxTpRatios)) {
    targetMaxTpRatios = maxTakeProfitP;

    return targetMaxTpRatios;
  }

  // have defined maxTpRatios array, find the proper value, docs
  // sort it from low -> high, find the first item that have leverage bigger than the pass in leverage
  const sortedRatios = currentPairMaxTpRatios.sort(
    (a, b) => a.leverage - b.leverage
  );

  const targetMaxTpRatiosObj =
    sortedRatios.find((v) => leverage <= v.leverage) ??
    sortedRatios[sortedRatios.length - 1];

  if (isNil(targetMaxTpRatiosObj)) {
    throw new Error('No proper maxTpRatios found');
  }

  targetMaxTpRatios = targetMaxTpRatiosObj.maxTakeProfitP;

  return targetMaxTpRatios;
};
